import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { useTranslations } from "use-intl";
import { useIsFlowActive } from "../../flow/hooks/useIsFlowActive";
import { ReceiptTotalDisplay } from "../Receipt";
import { QuoteReceiptTotalFragment } from "./QuoteReceiptTotal.fragment";
export const QuoteReceiptTotal = t0 => {
  const $ = _c(6);
  const {
    item: totalPriceKey
  } = t0;
  const isCheckoutFlow = useIsFlowActive("checkout");
  const totalPrice = readFragment(QuoteReceiptTotalFragment, totalPriceKey);
  const t = useTranslations("wallet.QuoteReceiptTotal");
  const prices = totalPrice.pricePerToken.map(_temp);
  let t1;
  if ($[0] !== isCheckoutFlow || $[1] !== t) {
    t1 = isCheckoutFlow ? t("total") : t("totalEstProceeds");
    $[0] = isCheckoutFlow;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const label = t1;
  let t2;
  if ($[3] !== label || $[4] !== prices) {
    t2 = <ReceiptTotalDisplay label={label} prices={prices} />;
    $[3] = label;
    $[4] = prices;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
function _temp(price) {
  return {
    unit: price.token.unit,
    symbol: price.token.symbol,
    usd: price.usd
  };
}